import { Loader } from "@sendgrid/ui-components/loader";
import Styles from "./Loading.module.scss";

export const Loading = () => (
  <div className={Styles["full-page-load"]}>
    <Loader large />
  </div>
);
